'use strict';

var App = require('app');

var ConfirmDeleteDevicesDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/confirm_delete_devices'),

    events: {
        'click a#js-action': 'actionClicked',
        'click a': 'closeModal',
    },

    serializeData: function () {
        if ($.isEmptyObject(this.options.sourceDeviceInfos)) {
            this.options.sourceDeviceInfos = undefined;
        }

        var deviceModel = function (options) {
            return $.extend({ modelType: 'device', tab: 'status-data' }, options);
        };

        // Extend device infos
        var totalEntries = 0;
        _.each(this.options.sourceDeviceInfos, function (source) {
            source.device = deviceModel(source.device);
            _.each(source.targets, function (target) {
                totalEntries += target.data_points.length;
                target.device = deviceModel(target.device);
                if (totalEntries > 9) {
                    source.targets[source.targets.length] = { andMore: true };
                    return;
                }
            });
        });

        return $.extend(true, { sourceDeviceInfos: this.options.sourceDeviceInfos }, this.options);
    },

    closeModal: function (e) {
        App.hideModal();
    },

    actionClicked: function (e) {
        e.preventDefault();

        App.hideModal();
        this.options.action_cb();
    },
});

module.exports = ConfirmDeleteDevicesDialogView;
